import clsHttp from '@cls/clsHttp'

/**
 * Keep the default implementation.
 */
class clsHttpExt extends clsHttp {} 

export default clsHttpExt;
